<div id="container">
    <h1>Are you sure you want to kill the process?
    </h1>
    <div id="buttonContainer">
        <button mat-button id="confirmKillButton" [mat-dialog-close]="true">Kill Process</button>
        <button mat-button id= "cancelKillButton" [mat-dialog-close]="false">Cancel</button>
    </div>
    
</div>
